import { lazy } from "react";

const Homepage = lazy(() => import("../../views/news/dashboards/main-view"));
const Servicing = lazy(() => import("../../views/news/dashboards/servicing"));
const Origination = lazy(() =>
  import("../../views/news/dashboards/origination")
);
const CapitalMarkets = lazy(() =>
  import("../../views/news/dashboards/capital-markets")
);

const DashboardRoutes = [
  {
    path: "/origination",
    element: <Origination />,
  },
  {
    path: "/dashboard",
    element: <Homepage />,
  },
  {
    path: "/servicing",
    element: <Servicing />,
  },
  {
    path: "/capital-markets",
    element: <CapitalMarkets />,
  },
];

export default DashboardRoutes;
